import { connect } from 'react-redux';
import { List, Map } from 'immutable';
import { request as queryCompetitions } from '../../modules/competitions/actions/query';
import { request as getSports } from '../../modules/sports/actions/get';

import decorate from '../../utils/decorate';

import { request } from '../../modules/events/actions/create';

import CreateEventModal from './CreateEventModal.jsx';

const STATE_KEY = 'create-event-modal';

function mapStateToProps(state, props) {
    const participants = state.participants.getIn([ 'collections', STATE_KEY, 'items' ]) || List();


    return {
        id: state.events.getIn([ 'create', 'id' ]),
        state: state.events.getIn([ 'create', 'state' ]),
        sports: state.sports.get('items', Map()),
        competitions: state.competitions.get( 'items', Map() ),
        competitionsCollection: state.competitions.get( 'collections' ),
        participants: participants.map(id => state.participants.getIn([ 'items', +id ]))
    };
}
function mapDispatchToProps(dispatch, props) {
    return {
        onCreateRequest: (data) => dispatch(request(data)),
        onLoadCompetitionsRequest: ( sportId, query ) => dispatch( queryCompetitions( sportId, query ) ),
        onLoadSportsRequest: () => dispatch(getSports())
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    CreateEventModal
);
